const menu = () => {
  const navigation = document.getElementsByClassName('js-menu');
  const openButton = document.getElementsByClassName('js-menu-open');
  const closeButton = document.getElementsByClassName('js-menu-close');

  const toggleMenuState = () => {
    closeButton[0].classList.toggle('hidden');
    navigation[0].classList.toggle('hidden');
    navigation[0].classList.toggle('flex');
    document.querySelector('header').classList.toggle('menu-open');
    navigation[0].classList.toggle('hidden');
    document.querySelector('.js-menu-button-wrapper').classList.toggle('hidden');
  };

  if(openButton) {
    openButton[0].addEventListener('click', toggleMenuState);
  }
  if(closeButton) {
    closeButton[0].addEventListener('click', toggleMenuState);
  }

};

export default menu;
